import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {
	FreudAccordionModule,
	FreudTypographyModule,
} from '@freud-ds/web-components';
import { TranslateModule } from '@ngx-translate/core';

import { PromptuaryQualityDescription } from './promptuary-quality-description.component';

@NgModule({
	declarations: [PromptuaryQualityDescription],
	imports: [
		CommonModule,
		TranslateModule.forChild(),
		FreudTypographyModule,
		FreudAccordionModule,
	],
	exports: [PromptuaryQualityDescription],
	providers: [],
})
export class PromptuaryQualityDescriptionModule {}
